import axios from 'axios';
import { toast } from 'react-toastify';
import { Encryption } from './global';

const isLocalhost = window.location.hostname === "localhost";

const apiUrl = isLocalhost
    ? "https://fpapi.finnovate.in/api/" // your local API
    : window.location.hostname === "plan.finnovate.in"
        ? "https://planapi.finnovate.in/api/"
        : "https://fpapi.finnovate.in/api/";

const axioInstance = axios.create({
    baseURL: apiUrl,
    headers: {
        'Access-Control-Allow-Origin': '*',
        'Content-Type': 'application/json',
    }
});

let isSessionExpired = false;

// Request Interceptor: Token + Encrypt `gw` header (only for non-localhost)
axioInstance.interceptors.request.use(
    (config) => {
        if (isSessionExpired) {
            return Promise.reject(new axios.Cancel('Session expired, no further requests allowed.'));
        }

        const token = sessionStorage.getItem('token');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }

        // ✅ Add encrypted gw header only for non-localhost
        if (!isLocalhost && config.url && !config.url.startsWith('http')) {
            const relativeUrl = config.url.replace(/^\/+/, '');
            const encryptedEndpoint = Encryption(relativeUrl);
            config.url = '/gw';
            config.headers.gw = encryptedEndpoint;
        }

        return config;
    },
    (error) => Promise.reject(error)
);

// Response Interceptor
axioInstance.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response) {
            const { status, data } = error.response;

            if (status === 401 || data?.message === "Token Expired") {
                if (!isSessionExpired) {
                    isSessionExpired = true;

                    toast.error("Session expired! Redirecting to sign-in...", {
                        position: "top-right",
                        autoClose: 3000,
                    });

                    setTimeout(() => {
                        sessionStorage.removeItem('token');
                        window.location.href = "sign-in";
                    }, 3000);
                }
            } else {
                if (sessionStorage.getItem('admin_id') === 1) {
                    toast.error(data?.message || "An error occurred!", {
                        position: "top-right",
                        autoClose: 3000,
                    });
                } else {
                    toast.error("An error occurred. Please try again after sometimes", {
                        position: "top-right",
                        autoClose: 3000,
                    });
                }
            }
        }

        return Promise.reject(error);
    }
);

export default axioInstance;
